import Box from '@mui/material/Box';
import {
  MaliciousScoreFactorsChart,
  ThreatTypeDistributionChartCard,
  ProfileCategoriesBarChart,
  QContainer,
  QCard,
  QCardHeader,
  QDivider,
  QCardContent,
} from '@kw/quokka-ui';

import { getMaliciousThreatLevel, getMaliciousThreatTypes } from '../utils/dopplerUtil';
import { PermissionsChart } from '../charts/PermissionsChart';
import { BehaviorsChartCard } from '../charts/BehaviorsChart';
import { RulesTab } from './RulesTab';
import { PermissionSummary } from '../types/ReportTypes';

interface AggregateData {
  permissionSummary?: PermissionSummary[];
}

interface IProps {
  ruleSummaries: any;
  analysisId: string;
  maliciousResult: object;
  aggregateData: AggregateData;
}

export function MaliciousTab({ ruleSummaries, analysisId, maliciousResult, aggregateData }: IProps) {
  const farmAppUuid = analysisId;
  const maliciousScore = getMaliciousThreatLevel(maliciousResult);
  const maliciousThreatTypes = getMaliciousThreatTypes(maliciousResult);

  return (
    <QContainer
      fluid
      sx={{
        maxWidth: '100% !important',
        display: 'flex',
        flexDirection: 'column',
        rowGap: 2,
        padding: '0px !important',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '36fr 36fr minMax(0, 24fr)',
          gridTemplateRows: '50% 49%',
          boxSizing: 'border-box',
          gap: '16px',
        }}
      >
        <Box sx={{ gridColumn: '1', gridRow: '1' }}>
          <MaliciousScoreFactorsChart score={maliciousScore} threatTypes={maliciousThreatTypes} />
        </Box>
        <Box sx={{ gridColumn: '2', gridRow: '1' }}>
          <ThreatTypeDistributionChartCard threatTypes={maliciousThreatTypes} />
        </Box>
        <Box sx={{ gridColumn: '3', gridRow: '1' }}>
          <PermissionsChart
            permissionsSummary={aggregateData?.permissionSummary}
            height={310}
            legendPosition="bottom"
            legendNumColumns={2}
          />
        </Box>
        <Box sx={{ gridColumn: '1 / span 2', gridRow: '2' }}>
          <ProfileCategoriesBarChart results={ruleSummaries.map(behavior => behavior.details)} />
        </Box>
        <Box sx={{ gridColumn: '3', gridRow: '2' }}>
          <BehaviorsChartCard results={ruleSummaries.map(behavior => behavior.details)} legendPosition="bottom" legendNumColumns={3} />
        </Box>
      </Box>
      <QCard
        sx={{
          padding: '0',
          boxShadow: 'none',
          borderRadius: '0',
        }}
      >
        <QCardHeader disableTypography title="Behaviors" />
        <QDivider />
        <QCardContent sx={{ padding: '0px !important' }}>
          <QDivider sx={{ borderColor: '#E0E0E0' }} />
          <RulesTab ruleSummaries={ruleSummaries} analysisId={farmAppUuid} section="malicious" />
        </QCardContent>
      </QCard>
    </QContainer>
  );
}
